// src/features/execucao/api.js
import api from "../../api/axios";

/* =========================
   Workflow / Execução
========================= */

/**
 * Lista programações diretamente do backend já filtradas.
 * @param {{ data?: string, etapa?: "execucao"|"d1", include_finalizados?: 0|1 }} params
 */
export async function listarProgramacoes(params = {}) {
  const { data, etapa = "execucao", include_finalizados = 0 } = params;
  const { data: resp } = await api.get("/workflow/listar", {
    params: { data, etapa, include_finalizados },
  });
  if (resp?.ok && Array.isArray(resp.data)) return resp.data;
  if (Array.isArray(resp)) return resp;
  return [];
}

/**
 * SALVAR Execução (editar os campos da execução sem sair da etapa)
 * POST /workflow/w3/editar
 */
export async function salvarExecucao(payload) {
  const clean = { ...payload };
  // O backend (w3.edicao.js) já ignora campos que não devem ser alterados pelo usuário.
  const { data } = await api.post("/workflow/w3/editar", clean);
  if (data?.ok === false) throw new Error(data?.error || "Falha ao salvar execução");
  return data;
}

/**
 * REPROGRAMAR Execução (volta para D1 e limpa campos de execução)
 * POST /workflow/execucao/reprogramar
 */
export async function reprogramarExecucao(payload) {
  const clean = { ...payload };
  const { data } = await api.post("/workflow/execucao/reprogramar", clean);
  if (data?.ok === false) throw new Error(data?.error || "Falha ao reprogramar");
  return data;
}

/**
 * AVANÇAR ETAPA (para telas D+1, etc.) — não use na Execução.
 * ⚠️ ESTE ENDPOINT AINDA NÃO EXISTE NO BACKEND ATUAL
 * POST /workflow/avancar-etapa
 */
export async function avancarEtapa(payload) {
  const { data } = await api.post("/workflow/avancar-etapa", payload);
  if (data?.ok === false) throw new Error(data?.error || "Falha ao avançar etapa");
  return data;
}

/* =========================
   Apoios (catálogos)
========================= */
export async function getAtivosNomes() {
  const { data } = await api.get("/ativos/nomes");
  return data?.data || [];
}
export async function getAtividadesNomes() {
  const { data } = await api.get("/atividades/nomes");
  return data?.data || [];
}

/* Equipamentos (filtros em cascata e validações) */
export async function getGerencias() {
  const { data } = await api.get("/equipamentos/gerencias");
  return data?.data || [];
}
export async function getCoordenadores(gerencia) {
  const { data } = await api.get("/equipamentos/coordenadores", {
    params: { gerencia_nome: gerencia },
  });
  return data?.data || [];
}
export async function getSubs(coordenador) {
  const { data } = await api.get("/equipamentos/subs", {
    params: { coordenador_nome: coordenador },
  });
  return data?.data || [];
}
export async function getSbs(coordenador) {
  const { data } = await api.get("/equipamentos/sbs", {
    params: { coordenador_nome: coordenador },
  });
  return data?.sbs || [];
}
export async function validarKm(subdivisao_id, kmInicio, kmFinal) {
  const { data } = await api.get("/equipamentos/validar-km", {
    params: { subdivisao_id, kmInicio, kmFinal },
  });
  return data;
}
export async function sbKm(subdivisao_id, kmInicio, kmFinal) {
  const { data } = await api.get("/equipamentos/sb-km", {
    params: { subdivisao_id, kmInicio, kmFinal },
  });
  return data?.sbs || [];
}

/* Desvios (para reprogramação/fechamento) */
export async function getCausadores() {
  const { data } = await api.get("/desvios/causadores");
  return data?.data || [];
}
export async function getCausasPrimarias(causador) {
  const { data } = await api.get("/desvios/causas-primarias", {
    params: { causador },
  });
  return data?.data || [];
}
export async function getCausasSecundarias(causador, causa_primaria) {
  const { data } = await api.get("/desvios/causas-secundarias", {
    params: { causador, causa_primaria },
  });
  const list = data?.data || [];
  return list.map((x) => (typeof x === "string" ? x : x.causa_secundaria));
}
